import React from "react";
import CannotDeleteAdminModal from "./CannotDeleteAdminModal";
import { Modal } from "@tyrannosaurustech/ui";

interface DeleteUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedUser: any;
  onDelete: () => void;
  canDeleteUser?: boolean;
  isLoading: boolean;
}

export const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  isOpen,
  onClose,
  selectedUser,
  onDelete,
  isLoading,
  canDeleteUser = true,
}) => {
  return (
    <>
      <Modal
        title="Delete User"
        icon="ExclamationTriangleIcon"
        open={isOpen && canDeleteUser}
        bodyText={`Are you sure you want to delete ${
          selectedUser?.name ? selectedUser?.name : "this user"
        }? This action cannot be undone.`}
        confirmText="Delete"
        variant="danger"
        onConfirm={onDelete}
        loading={isLoading}
        setOpen={() => onClose()}
      />
      <CannotDeleteAdminModal
        isOpen={isOpen && !canDeleteUser}
        onConfirm={() => onClose()}
      />
    </>
  );
};
